/* ============================================================
   ÉLAN CORVANI — interações da home (prefixo ec-)
   Acordeão das regiões + filtro da vitrine.
   Reinicializa no editor de temas, igual ao custom-motion.js.
   ============================================================ */

(function () {
  'use strict';

  /* ---------- 1. ACORDEÃO DAS REGIÕES ---------- */

  function initRegioes(scope) {
    scope.querySelectorAll('[data-ec-regioes]').forEach(function (grade) {
      if (grade.dataset.ecBound === 'true') return;
      grade.dataset.ecBound = 'true';

      var regioes = grade.querySelectorAll('[data-ec-regiao]');

      regioes.forEach(function (r) {
        var abrir = function () {
          regioes.forEach(function (x) {
            x.classList.remove('ec-aberta');
          });
          r.classList.add('ec-aberta');
        };

        r.addEventListener('mouseenter', abrir);
        r.addEventListener('focusin', abrir);
        // no toque o 1º clique abre; se já está aberta, o clique navega pelo link interno
        r.addEventListener('click', function (e) {
          if (!r.classList.contains('ec-aberta')) {
            e.preventDefault();
            abrir();
          }
        });
      });
    });
  }

  /* ---------- 2. FILTRO DA VITRINE ---------- */

  function initVitrine(scope) {
    scope.querySelectorAll('[data-ec-vitrine]').forEach(function (sec) {
      if (sec.dataset.ecBound === 'true') return;
      sec.dataset.ecBound = 'true';

      var chips = sec.querySelectorAll('[data-ec-filtro]');
      var produtos = sec.querySelectorAll('[data-ec-col]');

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (x) {
            x.classList.remove('ec-ativo');
            x.setAttribute('aria-pressed', 'false');
          });
          chip.classList.add('ec-ativo');
          chip.setAttribute('aria-pressed', 'true');

          var f = chip.dataset.ecFiltro;
          produtos.forEach(function (p) {
            p.style.display = (f === 'todos' || p.dataset.ecCol === f) ? '' : 'none';
          });
        });
      });
    });
  }

  /* ---------- BOOT ---------- */

  window.ECHome = window.ECHome || {};

  window.ECHome.init = function (scope) {
    var root = scope || document;
    initRegioes(root);
    initVitrine(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.ECHome.init();
    });
  } else {
    window.ECHome.init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    window.ECHome.init(e.target);
  });

  document.addEventListener('shopify:section:select', function (e) {
    window.ECHome.init(e.target);
  });
})();
